// @lib-generic-ui
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { useGlobalRefs } from "context/react-lib/generic-ui/GlobalRefContext";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { modalsActions } from "store/react-lib/generic-ui/modals";
import CloseIcon from "@mui/icons-material/Close";

export default function ReduxModal({
  name,
  title,
  closeCallback = () => {},
  children,
  closeButtonProps = {},
  dialogActions = null,
  ...props
}) {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.modals[name]);
  const globalRefs = useGlobalRefs();

  const handleClose = () => {
    closeCallback();
    if (globalRefs.modalFocusRef.current)
      globalRefs.modalFocusRef.current.focus();
    dispatch(modalsActions.closeModal(name));
  };

  const open = Boolean(state?.open);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      {...props}
      sx={{
        ...(props.sx || {}),
        //position: "relative",
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        {dialogActions}
      </DialogActions>
      <IconButton
        sx={{
          position: "absolute",
          right: 3,
          top: 3,
        }}
        {...closeButtonProps}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
    </Dialog>
  );
}
